__turbopack_context__.v({
  "HelperText": "TextField-module-scss-module__cuzwnq__HelperText",
  "Input": "TextField-module-scss-module__cuzwnq__Input",
  "InputRoot": "TextField-module-scss-module__cuzwnq__InputRoot",
  "Scrollable": "TextField-module-scss-module__cuzwnq__Scrollable",
  "TextFieldWrapper": "TextField-module-scss-module__cuzwnq__TextFieldWrapper",
  "Typography": "TextField-module-scss-module__cuzwnq__Typography",
  "Typography___edit": "TextField-module-scss-module__cuzwnq__Typography___edit",
  "Typography___multiline": "TextField-module-scss-module__cuzwnq__Typography___multiline",
});
